'use client'

import { Button, SingleItinerary } from '@/components/uiComponents'
import useLoggedUser from '@/features/auth/hooks/useLoggedUser'
import useCurrentMarket from '@/features/caching/hooks/useCurrentMarket'
import { useFlyerBuilderState } from '@/features/flyer/store/FlyerBuilderStateProvider'
import { TranslationBundles } from '@/features/sitecore/configs/translation-bundles'
import { useSitecoreState } from '@/features/sitecore/store/useSitecoreState'
import { _isFeatureEnabled } from '@/utils/environment/feature-flags'
import { useGoogleAnalytics } from '@/utils/hooks/useGoogleAnalitics'
import Image from 'next/image'
import { useEffect } from 'react'
import add_box from '../../../../public/images/add_box.png'

const ItineraryStep = () => {
	const sitecoreStore = useSitecoreState((state) => state)
	const flyerBuilderState = useFlyerBuilderState((state) => ({
		addItinerary: state.addItinerary,
		removeItinerary: state.removeItinerary,
		nextButtonEnabled: state.nextButtonEnabled,
	}))
	const itineraries = useFlyerBuilderState((state) => state.steps.itinerary.itineraries)
	const { pushLabelClickedEvent } = useGoogleAnalytics()
	const market = useCurrentMarket()
	const user = useLoggedUser()

	//TODO DELETE NEW-BUILD-YOUR-FLYER-ACTIVATION (remove all byfActivation occurrences)
	const byfActivationKey = sitecoreStore.getLabel(TranslationBundles.FEATURES_ACTIVATION, 'MSC-NEW-BUILD-YOUR-FLYER-ACTIVATION', '')
	const isNewBYFEnabled = _isFeatureEnabled(byfActivationKey, market, user)

	useEffect(() => pushLabelClickedEvent({ event: 'stepView', eventName: 'step_view', label_clicked: 'Select an itinerary' }), [])

	const selectItineraryLabel = sitecoreStore.getLabel(TranslationBundles.BUILD_YOUR_FLYER, 'MSC-BUILD_YOUR_FLYER-SELECT-AN-ITINERARY', 'Select an itinerary')
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const addItineraryLabel = sitecoreStore.getLabel(TranslationBundles.BUILD_YOUR_FLYER, 'MSC-BUILD_YOUR_FLYER-ADD-ITIN', 'Add itinerary')

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const handleAddItinerary = () => {
		const newItineraryId = itineraries.length
		flyerBuilderState.addItinerary(newItineraryId)
	}

	const handleRemoveItinerary = (idToRemove: number) => {
		flyerBuilderState.removeItinerary(idToRemove)
	}
	const isAddItineraryButtonActive = !flyerBuilderState.nextButtonEnabled || itineraries.length === 5
	return (
		<div className="w-[372px]">
			<div className="flex justify-between items-center mb-10">
				<h2 className="text-sm font-bold uppercase">{selectItineraryLabel}</h2>
				{isNewBYFEnabled && (
					<Button variant="outlined" className="border border-[#000033] rounded-[3px] py-[6px] px-[6px] pl-[8px] flex justify-center items-center gap-[6px]" disabled={isAddItineraryButtonActive} onClick={handleAddItinerary}>
						<span className="text-xs font-normal inline-flex items-center">{addItineraryLabel}</span>
						<Image src={add_box} height={12} width={12} alt={''}></Image>
					</Button>
				)}
			</div>
			{itineraries.map((itinerary) => (
				<SingleItinerary key={itinerary.id} itineraryIndex={itinerary.id} onRemove={() => handleRemoveItinerary(itinerary.id)} />
			))}
		</div>
	)
}

export { ItineraryStep }
